const COD_CONSULTORIO_VIRTUAL = 6;

export const isConsultorioVirtual = (codUnidade: number): boolean => {
  return codUnidade === COD_CONSULTORIO_VIRTUAL;
};
